import axios from 'axios';
import { EventBus } from "@/event-bus";
import { RequestTools } from "./RequestTools";
import { AuthTools } from "./AuthTools";

export class InstanceConfigs {

    constructor() {
        this.requestTools = new RequestTools();
        this.authTools = new AuthTools();
        this.preffix = "ic_";
        this.allConfigLoadKey = this.preffix + "allconfigsload";
    }

    async loadAll() {

        if (false === this.authTools.hasJwt()) {
            return;
        }

        if (this.allConfigIsLoad()) {
            return;
        }

        const response = await this.requestTools.requestGet("/configProvider");

        response.configs.map((config) => {
            window.localStorage.setItem(this.preffix + config.name, config.value);
        });

        this.setAllLoadded();
    }

    getConfig(name) {
        let value = window.localStorage.getItem(this.preffix + name);
        return value;
    }

    setAllLoadded() {
        window.localStorage.setItem(this.allConfigLoadKey, "1");
    }

    allConfigIsLoad() {
        return "1" === window.localStorage.getItem(this.allConfigLoadKey);
    }


}